import { ref } from 'vue';

const singleTraining = () => {
    const singleTraining_error = ref(null);
    const singleTrainingResponse = ref(null);
    const addEmployee_error = ref(null);
    const addEmployeeResponse = ref(null);

    const create = async (trainingBase) => {

        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'POST',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(trainingBase)
        };

        console.log("requestOptions: ", requestOptions);
        console.log("trainingBase: ", trainingBase);

        try {
            let response = await fetch("/api/trainings", requestOptions);

            if (!response.ok) {
                singleTraining_error.value = response.status + ' - ' + response.statusText;
                console.log(singleTraining_error.value);
            }
            console.log("got here after not ok: ", response);
            let data = await response.json();
            singleTrainingResponse.value = data;
        } catch (err) {
            singleTraining_error.value = err.message;
        }
    }

    const addEmployee = async (employeeData) => {

        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(employeeData)
        };

        try {
            let response = await fetch("/api/trainings/assignemployee", requestOptions);

            if (!response.ok) {
                addEmployee_error.value = response.status + ' - ' + response.statusText;
                console.log(addEmployee_error.value);
            }

            let data = await response.json();
            addEmployeeResponse.value = data;
        } catch (err) {
            addEmployee_error.value = err.message;
        }
    }

    return { singleTrainingResponse, singleTraining_error, addEmployeeResponse, addEmployee_error, create, addEmployee };
}


function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default singleTraining;